import { SuperAdminService } from "services/superAdminService";

class UsersSAService extends SuperAdminService<any> {
  constructor() {
    super("users");
  }
}
export default new UsersSAService();
